import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { BUSINESS_MAP_URL } from '../config/businessInfo';
import './PolicyPages.css';

const FaqPage = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-page">
            <div className="policy-hero">
                <div className="container">
                    <div style={{ marginBottom: '0.85rem' }}>
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="product-page-back-btn"
                            aria-label="Go back"
                        >
                            <FiArrowLeft /> Back
                        </button>
                    </div>
                    <h1>Frequently asked questions</h1>
                    <p>
                        Quick answers about ordering, delivery, installments, and
                        support at Rahber Corporation.
                    </p>
                </div>
            </div>

            <div className="container policy-body">
                <article className="policy-prose">
                    <p className="lead">
                        Can’t find what you need?{' '}
                        <Link to="/contact">Contact our team</Link>, we are happy to
                        help.
                    </p>

                    <div className="faq-list">
                        <details className="faq-item">
                            <summary>What areas do you deliver to?</summary>
                            <div className="faq-answer">
                                <p>
                                    We provide exclusive showroom doorstep delivery throughout Lahore.
                                    All deliveries within Lahore are handled directly by our dedicated logistics
                                    crew to guarantee zero transit damage and prompt setup assistance.
                                </p>
                            </div>
                        </details>

                        <details className="faq-item">
                            <summary>
                                Can I buy on installment without visiting a showroom?
                            </summary>
                            <div className="faq-answer">
                                <p>
                                    Yes. You can explore plans online and complete
                                    documentation with our team digitally or in-store,
                                    depending on the product and plan. Visit our{' '}
                                    <Link to="/installment">Installment</Link> section
                                    for an overview, then reach out via{' '}
                                    <Link to="/contact">Contact</Link> or call us to
                                    finalize. You can also visit our Lahore showroom:{' '}
                                    <a
                                        href={BUSINESS_MAP_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        open directions on Google Maps
                                    </a>
                                    .
                                </p>
                            </div>
                        </details>

                        <details className="faq-item">
                            <summary>What payment methods do you accept?</summary>
                            <div className="faq-answer">
                                <p>
                                    We accept bank transfers, major debit/credit cards
                                    (where available), and cash-on-delivery for
                                    eligible orders. Installment plans are arranged
                                    through approved financing partners. Details are
                                    shared during application.
                                </p>
                            </div>
                        </details>

                        <details className="faq-item">
                            <summary>Are your products genuine and under warranty?</summary>
                            <div className="faq-answer">
                                <p>
                                    We only sell authentic products from authorized
                                    distributors. Manufacturer warranty terms apply as
                                    stated on the product page and warranty card. See
                                    our <Link to="/warranty">Warranty</Link> page for
                                    more detail.
                                </p>
                            </div>
                        </details>

                        <details className="faq-item">
                            <summary>Can I return or exchange a product?</summary>
                            <div className="faq-answer">
                                <p>
                                    Returns and exchanges follow our{' '}
                                    <Link to="/returns">Returns &amp; Exchange</Link>{' '}
                                    policy. In general, unused items in original
                                    packaging may qualify within the stated window;
                                    opened or installed appliances may be limited to
                                    warranty service.
                                </p>
                            </div>
                        </details>

                        <details className="faq-item">
                            <summary>How do I track my order?</summary>
                            <div className="faq-answer">
                                <p>
                                    After your order is confirmed, you’ll receive
                                    updates by SMS and/or email, including dispatch and
                                    delivery scheduling. For assistance, contact us with
                                    your order reference.
                                </p>
                            </div>
                        </details>

                        <details className="faq-item">
                            <summary>
                                Where can I follow deals and new arrivals?
                            </summary>
                            <div className="faq-answer">
                                <p>
                                    Follow Rahber Corporation on YouTube, Instagram,
                                    Facebook, and TikTok for the latest deals, hot
                                    installment offers, and limited stock updates.
                                    Links are in the website footer and on our{' '}
                                    <Link to="/contact">Contact</Link> page.
                                </p>
                            </div>
                        </details>

                        <details className="faq-item">
                            <summary>Do you offer installation for large appliances?</summary>
                            <div className="faq-answer">
                                <p>
                                    Installation may be included or available as an
                                    add-on depending on the product and city. Our team
                                    will confirm installation options and any fees
                                    before delivery.
                                </p>
                            </div>
                        </details>
                    </div>

                    <p className="policy-meta">
                        Last updated: March 2026
                    </p>
                </article>
            </div>
        </div>
    );
};

export default FaqPage;
